module.exports = __webpack_public_path__ + "img/folder.e5762d1c.webp";